// src/components/Common/LabelValueRow/LabelValueRow.jsx
import React from 'react';
import './LabelValueRow.less';

/**
 * Receipt-style label/value row component
 * Displays a label on the left and a value on the right
 * Following the design principles from the receipt UI
 */
const LabelValueRow = ({ label, value, muted = false, bold = false, className = '' }) => {
  return (
    <div className={`label-value-row ${muted ? 'label-value-row--muted' : ''} ${bold ? 'label-value-row--bold' : ''} ${className}`}>
      <span className="label-value-row__label">{label}</span>
      <span className="label-value-row__value">{value}</span>
    </div>
  );
};

export default LabelValueRow;
